export default {"src":"/_next/static/media/LL_pinklogo_text.ed447229.svg","height":359,"width":361};